<template>
  <div >
    <van-nav-bar
      title="素材上传"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-form @submit="toupload">
      <van-field name="radio" label="图片">
        <template #input>
          <van-uploader :after-read="upload" v-model="fileList" @delete="todelete" />
        </template>
      </van-field>


      <van-field name="radio" label="分类">
        <template #input>
          <van-radio-group v-model="radio" direction="horizontal">
            <van-radio :name="item.id" v-for="item in cate" :key="item.name" >{{item.name}}</van-radio>

          </van-radio-group>
        </template>
      </van-field>
       <van-field
          v-model="name"
          label="图片标题"
          placeholder="图片标题"

        />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" >提交</van-button>
      </div>
    </van-form>












  </div>
</template>

<script>
  import * as Api from './api.js'
import { ImagePreview,Toast } from 'vant';
import OSS from 'ali-oss'
import { Dialog } from 'vant';
import { uuid } from 'vue-uuid';
  export default {
    name: 'sucaiview',
    data () {
      return {
        value:'',
        fileList:[],
        cate:[],
        radio:'',
        name:'',
        flist:[],
        client:'',
        region:'oss-cn-beijing.aliyuncs.com',
        bucket:'mpjituan',
        endpoint:'oss-cn-beijing.aliyuncs.com',
        securityToken:'',
        accessKeyId:'',
        accessKeySecret:'',




      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo')
      this.getfenlei()
      Api.getAuthorization().then(res=>{
      	var that = this
      	this.accessKeyId = res.accessKeyId
      	this.accessKeySecret = res.accessKeySecret
      	this.securityToken = res.securityToken
      	console.log(this.accessKeyId)
      	this.client = new OSS({
      		region: that.region,
      		accessKeyId: that.accessKeyId,
      		accessKeySecret:that.accessKeySecret,
      		stsToken: that.securityToken,
      		bucket: that.bucket,
      		secure:true,
      		endpoint:that.endpoint,
      	})

      })

    },
    methods:{
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      getfenlei(){
        Api.getfenlei().then(res=>{
          this.cate = res.data.data
          console.log(res)
        })
      },


      upload(file){
      	// console.log(file)
      	let type = file.file.type.split('/')
      	let name ='exp/'+ uuid.v4() +'.'+ type[1]
      	let reader = new FileReader();//将图片2将转成 base64 格式
      	var that = this
      	reader.readAsArrayBuffer(file.file);//读取成功后的回调
      	file.rname = name
      	reader.onload=function(){
      		that.client.put(name, new Buffer(this.result)).then(res=>{
      			let url = 'https://static.mpkeji.com/'+name
      			that.flist.push(url)
            console.log('xa')
      		})
      	};

      },
      todelete(file){
      	for(let i=0;i<this.flist.length;i++){
      		console.log(this.flist[i])
      		if (this.flist[i]=='https://static.mpkeji.com/'+file.rname){
      			this.flist.splice(i,1)
      		}
      	}
      },
      toupload(){
        console.log(this.flist)
      	if(this.flist.length==0||this.catevalue==''||this.name==''){
      		Dialog.alert({
      		  message: '参数不得为空',
      		})
      		return false
      	}

      	var that = this
        let imgurl = this.flist.join(',')
        let canshu = {
        	name:this.name,
        	cate:this.radio,
        	images:imgurl,

        }
        Api.add(canshu).then(res=>{
        	console.log(res)
        	if(res.msg=='新增成功'){
        		Dialog.alert({
        		  message: '上传成功',
        		}).then(() => {
        		  that.flist = []
        		  that.fileList = []
        		  that.name = ''

        		});

        	}
        })





      },


    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/sucaiview/sucaiupload/index.vue